import { CampaignCard } from '@/components/CampaignCardVertical';
import { RestrictedComponent } from '@/layout/RestrictedComponent';
import { useMaterialEditStore } from '@/screens/MaterialEdit/store';
import { CampaignDto } from '@shelflix/trpc/routes/campaign/list/useCase';
import Icon from '@shelflix/ui-web/components/Icon';
import { Button } from '@shelflix/ui-web/components/ui/button';
import { useState } from 'react';

interface DefaultCampaignsProps {
  onPauseCampaign?: (campaignUuid: string, isPaused: boolean) => void;
  onRemoveCurrentCampaign?: (campaign: CampaignDto) => void;
  currentCampaign?: CampaignDto | null;
  defaultCampaign?: CampaignDto | null;
}

export function DefaultCampaigns({
  // onPauseCampaign,
  onRemoveCurrentCampaign,
  defaultCampaign,
  currentCampaign = null,
}: DefaultCampaignsProps) {
  const { setOpenModal } = useMaterialEditStore();
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div className="flex flex-col items-start gap-4">
      <div className="flex flex-row items-center gap-2">
        <Icon name="award_star" fill={1} size={20} className="text-gray-400" />
        <h3 className="text-md leading-5 font-semibold sm:text-xl">Campanha padrão</h3>
      </div>
      <div className="bg-gray-400]/15 mt-2 flex w-full min-w-[280px] rounded-[5px] border-2 border-gray-400 p-3 sm:max-w-[400px]">
        <div className="max-w-[100px] sm:max-w-[115px] md:max-w-[125px]">
          {defaultCampaign && (
            <CampaignCard
              showExpiration
              showTitle={false}
              campaign={defaultCampaign}
              key={defaultCampaign.uuid}
              showPreview={showPreview}
              actions={{
                onClick: () => setShowPreview(true),
                onCloseModal: () => setShowPreview(false),
              }}
            />
          )}
        </div>
        <div className="flex w-full flex-1 flex-col justify-between gap-1 px-2">
          <div className="font-medium">
            <strong className="text-md">{defaultCampaign?.name}</strong>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex justify-between text-xs">
              <span>Veiculação padrão quando não houverem campanhas agendadas.</span>
            </div>
          </div>
          <RestrictedComponent requiredScopes={['material:campaign']} behavior="hide">
            {currentCampaign && defaultCampaign?.uuid !== currentCampaign.uuid && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  onRemoveCurrentCampaign?.(currentCampaign);
                }}
              >
                <Icon name="play_arrow" fill={1} size={20} />
                <span className="text-xs sm:text-sm">Passar agora</span>
              </Button>
            )}

            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                setOpenModal({
                  type: 'default',
                  title: 'Alterar campanha padrão',
                  icon: 'award_star',
                });
              }}
            >
              <Icon name="award_star" fill={1} size={20} />
              <span className="text-xs sm:text-sm">Alterar padrão</span>
            </Button>
          </RestrictedComponent>
        </div>
      </div>
    </div>
  );
}
